@use "../../sass/global/global" as *;
@use "../../sass/mixins/nimbus" as mixins;

ux-iws-nb-product-comparison {
    display: block;
    width: 100%;
    padding: 15px 0 30px;
    box-sizing: border-box;
    position: relative;
    background-color: #f8f8f8;

    @media (min-width: 568px) {
        padding: 30px 0 60px;
    }

    @media (min-width: 1440px) {
        padding: 30px 30px 80px;
    }

    @media (min-width: 1600px) {
        padding: 30px calc(100% / 12) 100px;
    }

    table {
        width: 100%;
        table-layout: fixed;
    }

    thead,
    tbody {
        background-color: transparent;
    }

    td,
    th {
        text-align: left;
        padding: 10px;
        background-color: #fff;
        color: #000;
        border-bottom: 1px solid $color-black-5;
        @include font(light);
        font-size: 1rem;
        line-height: 1.375;
        overflow: hidden;
        hyphens: auto;
        vertical-align: top;
    }

    th {
        @include font(bold);
        vertical-align: top;
    }

    /* override patternlab table styles */
    /* stylelint-disable selector-max-compound-selectors */
    tbody tr:nth-child(odd) td,
    tbody tr:nth-child(odd) th {
        background-color: #fff;
    }
    /* stylelint-enable selector-max-compound-selectors */

    tbody td:first-of-type,
    thead td:first-of-type {
        @include mixins.nb-cta-blue-background();
    }

    thead th:first-of-type,
    tbody th:first-of-type {
        background-color: transparent !important;
        padding-left: 0;
    }

    tbody td {
        padding: 20px 30px;
    }

    /* stylelint-disable selector-max-compound-selectors */

    thead td > div {
        padding: 10px;
    }

    tbody td > div {
        padding: 20px;
    }

    thead th,
    thead td {
        border-bottom: 0 none transparent;
    }

    tbody tr:last-of-type th,
    tbody tr:last-of-type td {
        border-bottom: 0 none transparent;
    }
    /* stylelint-enable selector-max-compound-selectors */

    img {
        aspect-ratio: 3 / 2;
        display: block;
        width: 100%;
        height: auto;
        object-fit: cover;
    }

    h4 {
        @include font(light);
        font-size: 23px;
        line-height: 1.2;
        color: inherit;
        margin: 1em 0;
    }

    ux-button {
        width: 100%;
    }

    .is-hidden {
        display: none;
    }
}

.ux-iws-nb-product-comparison {
    &__header {
        padding: 30px 30px 15px;

        @media (min-width: 1024px) {
            padding: 30px;
        }

        @media (min-width: 1440px) {
            padding: 30px 0;
        }

        h2,
        h3,
        h4 {
            @include nb-heading(4, true);
            margin: 0;
        }
    }

    &__container {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        box-sizing: border-box;
    }

    &__table {
        display: none;

        @media (min-width: 1440px) {
            display: block;
        }
    }

    &__cards {
        display: flex;
        flex-flow: row nowrap;
        align-items: stretch;
        justify-content: flex-start;
        gap: 20px;
        padding: 30px;

        &::after {
            display: block;
            content: "";
            flex: 0 0 10px;
        }
    }

    &__card {
        display: flex;
        flex-direction: column;
        flex: 0 0 auto;
        width: 290px;
        background-color: #{$color-white};
        box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);

        ux-button {
            margin: 20px 0;
        }

        @media (min-width: 768px) {
            width: 400px;
        }
    }

    &__card:first-of-type {
        @include mixins.nb-cta-blue-background();
    }

    &__cell {
        > div {
            padding: 20px;
        }

        &:not(.ux-iws-nb-product-comparison__cell--header) {
            padding: 0 20px;
        }

        &:not(.ux-iws-nb-product-comparison__cell--header):not(:last-of-type)
            > div {
            border-bottom: 1px solid $color-black-5;
        }
    }

    &__cell-label,
    &__cell-value {
        display: block;
        font-size: 1rem;
        line-height: 1.375;
        @include font(light);
    }

    &__cell-label {
        @include font(bold);
        margin-bottom: 10px;
    }
}
